// provincias_municipios.js
export const provinciasRD = [
    { provincia: '', municipios: [''] },
    { provincia: 'Seleccione', municipios: ['Seleccione'] },
    { provincia: 'Distrito Nacional', municipios: ['Distrito Nacional'] },
    {
        provincia: 'Azua', municipios: [
            'Azua', 'Estebanía', 'Guayabal', 'Las Charcas', 'Las Yayas de Viajama',
            'Padre Las Casas', 'Peralta', 'Pueblo Viejo', 'Sabana Yegua', 'Tábara Arriba'
        ]
    },
    { provincia: 'Bahoruco', municipios: ['Neiba', 'Galván', 'Los Ríos', 'Tamayo'] },
    {
        provincia: 'Barahona', municipios: [
            'Barahona', 'Cabral', 'Enriquillo', 'Fundación', 'Jaquimeyes',
            'La Ciénaga', 'Paraíso', 'Polo', 'Vicente Noble'
        ]
    },
    { provincia: 'Dajabón', municipios: ['Dajabón', 'Loma de Cabrera', 'Restauración'] },
    { provincia: 'Duarte', municipios: ['San Francisco de Macorís', 'Castillo', 'Pimentel', 'Villa Riva', 'Cayetano Germosén'] },
    { provincia: 'Elías Piña', municipios: ['Comendador', 'Bánica', 'El Llano', 'Hondo Valle', 'Postrer Río'] },
    { provincia: 'El Seibo', municipios: ['Santa Cruz del Seibo', 'Miches'] },
    { provincia: 'Espaillat', municipios: ['Moca', 'Gaspar Hernández', 'San Víctor'] },
    { provincia: 'Hato Mayor', municipios: ['Hato Mayor del Rey', 'Sabana de la Mar'] },
    { provincia: 'Hermanas Mirabal', municipios: ['Salcedo', 'Tenares', 'Villa Tapia'] },
    { provincia: 'Independencia', municipios: ['Jimaní', 'Duvergé', 'La Descubierta', 'Mella'] },
    { provincia: 'La Altagracia', municipios: ['Higüey', 'San Rafael del Yuma'] },
    { provincia: 'La Romana', municipios: ['La Romana'] },
    { provincia: 'La Vega', municipios: ['Concepción de La Vega', 'Jarabacoa', 'Jima Abajo'] },
    { provincia: 'Maria Trinidad Sánchez', municipios: ['Nagua', 'El Factor', 'Río San Juan'] },
    { provincia: 'Monseñor Nouel', municipios: ['Bonao', 'Maimón'] },
    { provincia: 'Monte Cristi', municipios: ['San Fernando de Monte Cristi', 'Guayubín', 'Villa Vásquez'] },
    { provincia: 'Monte Plata', municipios: ['Monte Plata', 'Bayaguana', 'Peralvillo', 'Sabana Grande de Boyá'] },
    { provincia: 'Pedernales', municipios: ['Pedernales'] },
    { provincia: 'Peravia', municipios: ['Baní', 'Nizao'] },
    {
        provincia: 'Puerto Plata', municipios: [
            'San Felipe de Puerto Plata', 'Altamira', 'Imbert', 'Luperón', 'Sosúa', 'Villa Isabela', 'Guananico'
        ]
    },
    { provincia: 'Samaná', municipios: ['Santa Bárbara de Samaná', 'Samaná'] },
    {
        provincia: 'San Cristóbal', municipios: [
            'San Cristóbal', 'Bajos de Haina', 'Cambita Garabitos', 'Los Cacaos', 'Yaguate', 'Villa Altagracia'
        ]
    },
    { provincia: 'San José de Ocoa', municipios: ['San José de Ocoa'] },
    { provincia: 'San Juan', municipios: ['San Juan de la Maguana', 'El Cercado', 'Las Matas de Farfán', 'Vallejuelo', 'Bohechío'] },
    {
        provincia: 'San Pedro de Macorís', municipios: [
            'San Pedro de Macorís', 'Guanoco', 'Playa de Ocoa', 'Quisqueya (San José de los Llanos)'
        ]
    },
    { provincia: 'Sánchez Ramírez', municipios: ['Cotuí', 'Fantino', 'Cevicos', 'La Mata'] },
    {
        provincia: 'Santiago', municipios: [
            'Santiago de los Caballeros', 'Bisonó', 'Jánico', 'Licey al Medio', 'Tamboril',
            'Villa González', 'Navarrete', 'Sabana Iglesia', 'San José de las Matas'
        ]
    },
    { provincia: 'Santiago Rodríguez', municipios: ['San Ignacio de Sabaneta', 'Monción'] },
    {
        provincia: 'Santo Domingo', municipios: [
            'Santo Domingo Este', 'Santo Domingo Norte', 'Santo Domingo Oeste',
            'Boca Chica', 'Los Alcarrizos', 'Pedro Brand', 'San Antonio de Guerra'
        ]
    },
    { provincia: 'Valverde', municipios: ['Mao', 'Esperanza', 'Laguna Salada'] }
];

